const Joi = require("joi");

const allowedMimeTypes = [
  "application/pdf",
  "application/msword", // .doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  "image/jpeg",
  "image/png",
  "image/webp",
  "application/vnd.ms-excel", // .xls
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
];

const CommitteeDocumentPageSchema = (data) => {
  const schema = Joi.object({
    title: Joi.string()
      .pattern(new RegExp("^[a-zA-Z0-9,.?/\" _@!@#%&*_'-]*$"))
      .trim()
      .required()
      .messages({
        "string.empty": "Please enter Title.",
        "any.required": "Please enter Title.",
        "string.pattern.base": "Please enter Valid Label.",
      }),

    category: Joi.string()
      .trim()
      .pattern(new RegExp("^[a-zA-Z0-9 ]*$"))
      .required()
      .messages({
        "string.pattern.base": "Please enter a valid Category.",
        "string.empty": "Please select Category.",
        "any.required": "Please select Category.",
      }),
    fileCheck: Joi.object({
      name: Joi.string().required(),
      type: Joi.string()
        .allow("") // <-- allows empty string without error
        .valid(...allowedMimeTypes)
        .messages({
          "any.only": "Unsupported file type. Only PDF, DOC, DOCX, JPG, PNG.",
        }),
    })
      .required()
      .messages({
        "any.required": "Please select a file.",
        "object.base": "Please select a file.",
      }),
  }).unknown(true);

  return schema.validate(data, { abortEarly: false });
};

module.exports = CommitteeDocumentPageSchema;
